import type { CustomCellRendererProps } from "ag-grid-react";
import Creator from "../Creator";
import { Flex } from "@unifize/sarah";

interface CellRendererProps extends CustomCellRendererProps {
  data: { id: number };
}

export const CreatorCellRenderer = ({
  data,
}: CellRendererProps): React.ReactElement => {
  return (
    <Flex>
      <Creator id={data.id} />
    </Flex>
  );
};
